import React from 'react';
import SignatureCanvas from 'react-signature-canvas';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from '../ui/dialog';
import { Button } from '../ui/button';

/**
 * Diálogo de firma digital.
 *
 * @param {boolean}  open
 * @param {function} onOpenChange
 * @param {object}   signatureRef   ref hacia el SignatureCanvas (compartido con el padre)
 * @param {function} onClear        handler para limpiar la firma
 * @param {function} onSave         handler para guardar la firma (setea base64 en el padre)
 */
export function SignatureDialog({ open, onOpenChange, signatureRef, onClear, onSave }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent style={{ maxWidth: '600px' }} data-testid="signature-dialog">
        <DialogHeader>
          <DialogTitle>Firma Digital</DialogTitle>
          <DialogDescription>
            Firma en el recuadro con tu dedo o ratón para confirmar la recepción
          </DialogDescription>
        </DialogHeader>
        <div style={{ padding: '20px' }}>
          <div style={{ border: '2px solid #2d8a4e', borderRadius: '8px', marginBottom: '16px' }}>
            <SignatureCanvas
              ref={signatureRef}
              canvasProps={{
                width: 550,
                height: 200,
                className: 'signature-canvas',
                style: { width: '100%', height: '200px' }
              }}
            />
          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <Button
              type="button"
              variant="outline"
              data-testid="signature-clear-button"
              onClick={onClear}
              style={{ flex: 1 }}
            >
              Limpiar
            </Button>
            <Button
              type="button"
              data-testid="signature-save-button"
              onClick={onSave}
              style={{ flex: 1, background: '#2d8a4e', color: '#fff' }}
            >
              Guardar Firma
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default SignatureDialog;
